/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ContentObjectType as t}from"./ContentObjectType.js";import{Geometry as r}from"./Geometry.js";class e extends r{constructor(r,e,o,n,s,i){super(r,e,null,t.Mesh,i),this.path=o,this.geometrySR=n,this.stencilWidth=s}}var o;function n(t){return"path"in t}!function(t){t[t.World=0]="World",t[t.Path=1]="Path"}(o||(o={}));export{e as PathGeometry,o as UpVectorAlignment,n as isPathGeometry};
